var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarretDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.031 14.4694L12.531 6.96939C12.4614 6.89965 12.3787 6.84433 12.2876 6.80659C12.1966 6.76885 12.099 6.74942 12.0004 6.74942C11.9019 6.74942 11.8043 6.76885 11.7132 6.80659C11.6222 6.84433 11.5394 6.89965 11.4698 6.96939L3.96979 14.4694C3.82906 14.6101 3.75 14.801 3.75 15C3.75 15.199 3.82906 15.3899 3.96979 15.5306C4.11052 15.6714 4.30139 15.7504 4.50042 15.7504C4.69944 15.7504 4.89031 15.6714 5.03104 15.5306L12.0004 8.56032L18.9698 15.5306C19.0395 15.6003 19.1222 15.6556 19.2132 15.6933C19.3043 15.731 19.4019 15.7504 19.5004 15.7504C19.599 15.7504 19.6965 15.731 19.7876 15.6933C19.8786 15.6556 19.9614 15.6003 20.031 15.5306C20.1007 15.461 20.156 15.3782 20.1937 15.2872C20.2314 15.1961 20.2508 15.0986 20.2508 15C20.2508 14.9015 20.2314 14.8039 20.1937 14.7128C20.156 14.6218 20.1007 14.5391 20.031 14.4694Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretDropdown);
export default __webpack_public_path__ + "static/media/CarretDropdown.261b2e59760b8d0a12632951efc5daea.svg";
export { ForwardRef as ReactComponent };